import Typography from "components/typography";

import React, { useState } from "react";
import styled from "styled-components";
import { Colors } from "utils/colors";
import IndependentCard from "./cards/independent-card";
import ProCard from "./cards/pro-card";
import LabelCard from "./cards/label-card";
import { ReactComponent as Waves } from "images/svg/processWaves.svg";
import { ReactComponent as Stars } from "images/svg/processStars.svg";

const Pricing = () => {
  const [isMonthly, setIsMonthly] = useState(true);

  return (
    <Container>
      <Typography
        size="4.8rem"
        m_size="2.8rem"
        weight="bold"
        mb="1.6"
        dataAos="fade-up"
      >
        Get Started As An Artist Or A Label
      </Typography>
      <Typography
        color={Colors.grey400}
        size="xl"
        m_size="m"
        mb="3.2"
        dataAos="fade-up"
      >
        Choose The Right Plan For Your Music Distribution
      </Typography>
      <StarsContainer>
        <Stars />
      </StarsContainer>
      <Body data-aos="fade-right">
        <Switch>
          <SwitchItem
            active={isMonthly ? "true" : "false"}
            onClick={() => {
              setIsMonthly(true);
            }}
          >
            <Typography>Monthly</Typography>
          </SwitchItem>
          <SwitchItem
            active={!isMonthly ? "true" : "false"}
            onClick={() => {
              setIsMonthly(false);
            }}
          >
            <Typography>Annually</Typography>
          </SwitchItem>
        </Switch>
        <Cards>
          <IndependentCard isMonthly={isMonthly} />
          <ProCard isMonthly={isMonthly} />
          <LabelCard isMonthly={isMonthly} />
        </Cards>
      </Body>
      <WaveContainer>
        <Waves />
      </WaveContainer>
    </Container>
  );
};

export default Pricing;

const Container = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  color: white;
  padding: 6.4rem 0;
  position: relative;
  overflow: hidden;
`;

const Body = styled.div`
  width: 80%;
  position: relative;
`;

const Switch = styled.div`
  padding: 0.3rem;
  border-radius: 0.8rem;
  border: 0.5px solid ${Colors.grey600};
  width: fit-content;
  margin-bottom: 3.2rem;
  display: flex;
  margin-right: auto;
  @media only screen and (max-width: 769px) {
    width: 100%;
    margin-bottom: 2.8rem;
  }
`;

const SwitchItem = styled.div<{ active: string }>`
  width: fit-content;
  padding: 0.5rem;
  display: flex;
  border-radius: 0.8rem;
  background-color: ${(props) =>
    props.active === "true" ? Colors.grey700 : ""};
  color: ${(props) =>
    props.active === "true" ? Colors.white100 : Colors.grey500};

  cursor: pointer;
  transition: 0.3s ease-out all;
  @media only screen and (max-width: 769px) {
    width: 50%;
    align-items: center;
    justify-content: center;
    padding: 1.2rem 0;
  }
`;

const Cards = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: 31% 31% 31%;
  justify-content: space-between;
  align-items: center;
  @media only screen and (max-width: 769px) {
    grid-template-columns: 100%;
    grid-row-gap: 2.4rem;
  }
`;

const WaveContainer = styled.div`
  width: 100%;
  margin-top: 6rem;
`;

const StarsContainer = styled.div`
  position: absolute;
  width: 100%;
  z-index: 0;
  @media only screen and (max-width: 769px) {
    display: none;
  }
`;
